import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticatedGuard } from '@references/shared/guards/authenticated.guard';
import { EnvironmentsService } from '@references/shared/services/environments.service';
import { NotFoundComponent } from '@shared/components/not-found/not-found.component';
import { CountriesService } from '@shared/services/countries.service';
import { UsersService } from '@shared/services/users.service';
import { CustomPreloadingStrategy } from '@shared/strategies/custom.preloading.strategy';

const routes: Routes = [
  {
    path: 'embed',
    loadChildren: () =>
      import('@references/embed/embed.module').then((m) => m.EmbedModule)
  },
  {
    path: '',
    loadChildren: () =>
      import('@references/protected/protected.module').then(
        (m) => m.ProtectedModule
      ),
    canActivate: [AuthenticatedGuard],
    resolve: {
      user: UsersService,
      countries: CountriesService
    }
  },
  {
    path: '',
    loadChildren: () =>
      import('@references/public/public.module').then((m) => m.PublicModule),
    resolve: {
      countries: CountriesService,
      environment: EnvironmentsService
    }
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      enableTracing: false,
      preloadingStrategy: CustomPreloadingStrategy
    })
  ],
  exports: [RouterModule]
})
export class CoreRoutingModule {}
